import React from 'react';
import { Check, ArrowRight, Sparkles, Flame } from 'lucide-react';

const STYLES = {
  best: {
    card: 'border-2 border-[#3B82F6] bg-gradient-to-b from-[#2563EB]/25 via-[#2563EB]/[0.08] to-transparent blue-glow ring-4 ring-[#3B82F6]/15 lg:-translate-y-4 lg:scale-[1.04] z-10',
    pill: 'bg-[#2563EB] text-white',
    cta: 'bg-[#2563EB] text-white hover:bg-[#1D4ED8] shadow-lg shadow-[#2563EB]/40',
  },
  popular: {
    card: 'border-2 border-white/40 bg-white/[0.06]',
    pill: 'bg-white text-[#0B0B0B]',
    cta: 'bg-white text-[#0B0B0B] hover:bg-white/90',
  },
  default: {
    card: 'border border-white/10 bg-white/[0.03]',
    cta: 'border-2 border-[#3B82F6]/60 text-white hover:bg-[#2563EB] hover:border-[#2563EB]',
  },
};

export default function HuntrPlanCard({ plan: p, price, symbol, annual }) {
  const s = STYLES[p.badge] || STYLES.default;
  const best = p.badge === 'best';
  const Icon = best ? Sparkles : Flame;
  return (
    <div className={`relative rounded-2xl p-7 flex flex-col ${s.card}`}>
      {p.badge && (
        <span className={`absolute -top-3.5 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-[0.16em] whitespace-nowrap shadow-lg ${s.pill}`}>
          <Icon className="w-3 h-3" /> {best ? 'Best Value' : 'Most Popular'}
        </span>
      )}
      <p className={`text-[10px] uppercase tracking-[0.18em] ${p.badge ? 'text-[#3B82F6] font-semibold' : 'text-white/45'}`}>{p.label}</p>
      <p className="mt-2 font-display font-semibold text-white text-xl">{p.leads} leads / day</p>
      <p className="text-xs text-white/45 mt-1">{best ? 'Lowest cost per lead' : p.badge ? 'Chosen by most teams' : p.note}</p>

      <div className="mt-6 flex items-end gap-1.5">
        <span className={`font-display font-bold text-white ${best ? 'text-5xl' : 'text-4xl'}`}>{symbol}{price.toLocaleString('en-US')}</span>
        <span className="text-xs text-white/45 mb-1.5">/ month</span>
      </div>
      <p className="text-[11px] text-white/40 mt-1.5 h-4">
        {annual ? 'Billed annually — 2 months free' : 'Billed monthly, cancel anytime'}
      </p>

      <ul className="mt-6 pt-6 border-t border-white/10 space-y-3 flex-1">
        {p.features.map((f) => (
          <li key={f} className={`flex gap-2.5 text-sm leading-snug ${p.badge ? 'text-white/85' : 'text-white/70'}`}>
            <Check className="w-4 h-4 text-[#3B82F6] shrink-0 mt-0.5" />
            {f}
          </li>
        ))}
      </ul>

      <a
        href="#huntr-start"
        className={`group mt-7 inline-flex items-center justify-center gap-2 h-14 rounded-lg text-sm font-bold transition-all duration-300 ${s.cta}`}
      >
        {best ? 'Get Scale — Best Value' : `Start ${p.label}`}
        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
      </a>
    </div>
  );
}